import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../FirebaseConfig";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import logoLight from "../assets/Logo/admin-logo.png";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const auth = getAuth();
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const log = signInWithEmailAndPassword(auth, email, password) // eslint-disable-line no-unused-vars
      .then((userCredentails) => {
        const user = userCredentails.user;

        toast.success("Welcome admin");
        if (user.email === "blackbeedigital90@gmail.com") {
          toast.success("Welcome admin");

          setEmail("");
          setPassword("");
          setTimeout(() => {
            navigate("/admin/add_blog");
          }, 1000);
        } else {
          toast.error("Invalid credentials");
        }
      })
      .catch((err) => {
        const errorMessage = err.message;
        console.error("error is ", errorMessage);
        toast.error("Invalid Credentials", errorMessage);
      });
  };

  return (
    <>
      <div className="container-fluid admin-login-container d-flex align-items-center justify-content-center m-0">
        <div className="content flex flex-col justify-center items-center">
          <div className="w-20">
            <Link to="/">
              <img src={logoLight} alt="blackbee logo" />
            </Link>{" "}
          </div>
          <div className="text-center">
            <h1 className="text-xl font-montserrat my-3 sign_in_title">
              Sign in to your account
            </h1>
          </div>
          <form
            className="flex flex-col justify-center items-center gap-4 "
            id="login"
            onSubmit={handleLogin}
          >
            <div className="content__inputs flex flex-col gap-1  text-black">
              <label htmlFor="email">
                Your Email <span>*</span>
              </label>
              <input
                required
                type="text"
                placeholder="xyz@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-96 rounded-xl p-2 outline-none"
              />
              <label htmlFor="email">
                Your Password <span>*</span>
              </label>
              <input
                required
                type="password"
                placeholder="xyz"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-96 rounded-xl p-2 outline-none"
              />
            </div>
            <button
              type="submit"
              className="text-center text-sm font-montserrat font-medium justify-center flex items-center gap-2 rounded-xl lg:py-4 lg:px-8 px-4 py-2 bg-[#FF4D30] text-white shadow-custom hover:shadow-custom-hovered transition-all duration-300 ease-in-out button w-40 mt-4"
            >
              Log In
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default SignIn;
